import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
import { getFunctions } from "firebase/functions";
import { getMessaging } from "firebase/messaging";
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";

// Tu configuración de Firebase
export const firebaseConfig = {
  apiKey: "AIzaSyB_bY0N9Tx1zrJlGTfkfUsewnYtTMcBOOw",
  authDomain: "kondify-app.firebaseapp.com",
  projectId: "kondify-app",
  storageBucket: "kondify-app.firebasestorage.app",
  messagingSenderId: "537883922577",
  appId: "1:537883922577:web:c3b2c6de52ec4777916f30",
  measurementId: "G-6PM9SKT5GV"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Inicializar App Check
if (typeof window !== 'undefined') {
  if (window.location.hostname === "localhost") {
    window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
  }
  try {
    initializeAppCheck(app, {
      provider: new ReCaptchaEnterpriseProvider('6LdBS3ktAAAAAPaXBXfRF5lxR2qK52y2tJ5k34Lc'), // Clave de reCAPTCHA Enterprise
      isTokenAutoRefreshEnabled: true
    });
  } catch (err) {
    console.warn("App Check failed to initialize:", err);
  }
}

// Inicializa todos los servicios
export let analytics;
if (typeof window !== 'undefined') {
  try {
    analytics = getAnalytics(app);
  } catch (e) {
    console.warn("Analytics not supported in this environment:", e);
  }
}
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const functions = getFunctions(app);
export let messaging;
if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
  try {
    messaging = getMessaging(app);
  } catch (e) {
    console.warn("Firebase Messaging not supported in this environment (likely Native).");
  }
}

// --- CONECTAR EMULADORES (SOLO LOCALHOST) ---
/*
if (window.location.hostname === "localhost") {
  console.log("📍 Conectando a Firebase Emulators...");
  // connectAuthEmulator(auth, "http://localhost:9099");
  // connectFirestoreEmulator(db, 'localhost', 8080);
  // connectStorageEmulator(storage, 'localhost', 9199);
  // connectFunctionsEmulator(functions, "localhost", 5001);
}
*/